<template >
  <div class="card-body">
    <div role="tabpanel" class="card-header">
      <div class="card-title">
        <h3>Ticket</h3>
      </div>
    </div>
    <div class="card card-body">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Assunto</label>
            <input type="text" class="form-control" v-model="ticket.subject" />
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div :class="[{ 'col-md-9': ticket.id }, { 'col-md-12': !ticket.id }]">
          <div role="tabpanel" class="card-header">
            <div class="card-title">
              <h3>Descrição</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ckeditor
                :editor="editor"
                v-model="ticket.description"
                :config="editorConfig"
              ></ckeditor>
            </div>
            <div class="card-body">
              <div class="col-md-12">
                <div class="block text-right">
                  <router-link to="/tickets" class="btn btn-info">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-success" @click="save">
                    Enviar
                    <i class="fa fa-save"></i>
                  </a>
                  <hr />
                </div>
              </div>
            </div>
          </div>
          <div v-if="ticket.id">
            <div
              class="card history-tickets"
              v-for="history in ticket.interactions"
              :key="history.id"
            >
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="container"
                    style="background-color: #fff"
                    v-if="history.order == '1'"
                  >
                    <h4 class="card-title text-left">Mensagem do Cliente</h4>
                    <br />
                    <span class="ticket-history" v-html="history.body"></span>
                    <br />
                    <span class="time-right">
                      <i>{{ history.created_at }}</i>
                    </span>
                  </div>

                  <div
                    class="container"
                    style="background-color: #deebff"
                    v-else-if="history.order == '3'"
                  >
                    <h4 class="card-title text-left">Alteração de Status</h4>
                    <br />
                    <span v-html="history.body"></span>
                    <br />
                    <span class="time-right">
                      <i>{{ history.created_at }}</i>
                    </span>
                  </div>

                  <div class="container darker text-left" v-else>
                    <h4 class="card-title text-right">Resposta InnovareTI</h4>
                    <br />
                    <span v-html="history.body"></span>

                    <span class="time-left">
                      <i>{{ history.created_at }}</i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3" v-if="ticket.id">
          <div role="tabpanel" class="card-header">
            <div class="card-title">
              <h3>Mais Informações</h3>
            </div>
          </div>

          <div class="row">
            <div class="container" style="background-color: #fff">
              <div role="tabpanel" class="card-header mb-3">
                <div class="card-title">
                  <h6>Responsável pelo chamado</h6>
                </div>
              </div>
              <div>
                <div class="row" v-if="ticket.responsible">
                  <div class="col-md-3">
                    <img
                      class="photo"
                      :src="ticket.responsible.photo"
                      alt="sunil"
                      width="70%"
                    />
                  </div>
                  <div class="col-md-9">
                    <div class="alert alert-info ipp-alert inline w-100">
                      {{ ticket.responsible.name }}
                    </div>
                  </div>
                </div>
                <div class="text-center" v-else>
                  Nenhuma pessoa acompanhando
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="container" style="background-color: #fff">
              <div role="tabpanel" class="card-header mb-3">
                <div class="card-title">
                  <h6>Horas de Atendimento</h6>
                </div>
              </div>
              <div v-if="ticket.service_hours && ticket.service_hours.length">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Início</th>
                      <th>Fim</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="service_hour in ticket.service_hours"
                      :key="service_hour.id"
                    >
                      <td>{{ service_hour.start | dateTime }}</td>
                      <td>{{ service_hour.end | dateTime }}</td>
                      <td>
                        {{
                          service_hour.start
                            | dateTimeDiff(service_hour.end)
                            | formatSeconds
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <hr />

                <div class="row">
                  <div class="col-md-12 text-center">
                    <b>Total:</b>
                    {{ calculateTotalTimeServiceHours() }} horas
                  </div>
                </div>
              </div>
              <div class="text-center" v-else>Nenhum lançamento registrado</div>
            </div>
          </div>
          <div
            class="row"
            v-if="ticket.attachments && ticket.attachments.length > 0"
          >
            <div class="container card-title" style="background-color: #fff">
              <div role="tabpanel" class="card-header">
                <div class="card-title">
                  <h6>Anexos do Chamado</h6>
                </div>
              </div>

              <div
                class="row"
                v-for="attachment in ticket.attachments"
                :key="attachment.id"
              >
                <div class="col-md-10">
                  <div
                    class="limit-text-long-card"
                    style="font-size: 12px; font-weight: normal"
                    v-if="attachment"
                  >
                    <a :href="attachment.path" target="_blank">{{
                      attachment.name
                    }}</a>
                  </div>
                </div>
                <div class="col-md-2">
                  <a :href="attachment.path" target="_blank">
                    <i class="fas fa-download"></i>
                  </a>
                </div>
              </div>
              <!-- Botão Modal Adicionar Anexos -->
              <div align="center" style="margin-top: 15px">
                <button
                  class="btn btn-primary btn-sm"
                  data-toggle="modal"
                  data-target="#attachModal"
                >
                  <i class="fas fa-paperclip"></i> Adicionar Anexo
                </button>
              </div>
              <!-- Modal Adicionar Anexos -->
              <div
                class="modal fade"
                id="attachModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="attachModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-lg" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="attachModalLabel">
                        Novo Anexo
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <input
                        type="file"
                        name="file"
                        class="form-control-file"
                        id="attachment"
                      />
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="saveAttachments()"
                        data-dismiss="modal"
                      >
                        Salvar
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        Fechar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="container card-title" style="background-color: #fff">
              <div role="tabpanel" class="card-header">
                <div class="card-title">
                  <h6>Anexos do Chamado</h6>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div
                    class="limit-text-long-card"
                    style="font-size: 12px; font-weight: normal"
                  >
                    <div class="text-center">Nenhum Registro</div>
                  </div>
                </div>
              </div>
              <!-- Botão Modal Adicionar Anexos -->
              <div align="center" style="margin-top: 15px">
                <button
                  class="btn btn-primary btn-sm"
                  data-toggle="modal"
                  data-target="#attachModal"
                >
                  <i class="fas fa-paperclip"></i> Adicionar Anexo
                </button>
              </div>
              <!-- Modal Adicionar Anexos -->
              <div
                class="modal fade"
                id="attachModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="attachModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-lg" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="attachModalLabel">
                        Novo Anexo
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <input
                        type="file"
                        name="file"
                        class="form-control-file"
                        id="attachment"
                      />
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="saveAttachments()"
                        data-dismiss="modal"
                      >
                        Salvar
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        Fechar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="row">
                        <div class="container" style="background-color: #fff;">
                            <div role="tabpanel" class="card-header mb-3">
                                <div class="card-title">
                                    <h6>Pessoas acompanhando este chamado</h6>
                                </div>
                            </div>
                            <div v-if="ticket.devs.length">
                                <div class="row" v-for="dev in ticket.devs" :key="dev.id">
                                    <div class="col-md-3">
                                        <img
                                            class="photo"
                                            :src="dev.user.photo"
                                            alt="sunil"
                                            width="70%"
                                        />
                                    </div>
                                    <div class="col-md-9">
                                        <div class="alert alert-info ipp-alert">{{dev.user.name}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center" v-else>Nenhuma pessoa acompanhando</div>
                        </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mask } from "vue-the-mask";
import vSelect from "vue-select";

class MyUploadAdapter {
  constructor(loader) {
    // The file loader instance to use during the upload.
    this.loader = loader;
  }

  // Starts the upload process.
  upload() {
    // Update the loader's progress.
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          this._initRequest();
          this._initListeners(resolve, reject, file);
          this._sendRequest(file);
        })
    );
  }

  // Aborts the upload process.
  abort() {
    // Reject the promise returned from the upload() method.
    if (this.xhr) {
      this.xhr.abort();
    }
  }

  // Initializes the XMLHttpRequest object using the URL passed to the constructor.
  _initRequest() {
    const xhr = (this.xhr = new XMLHttpRequest());

    // Note that your request may look different. It is up to you and your editor
    // integration to choose the right communication channel. This example uses
    // a POST request with JSON as a data structure but your configuration
    // could be different.
    xhr.open(
      "POST",
      "https://api.projetos.innovareti.com.br/api/v1/images/upload/",
      true
    );
    xhr.responseType = "json";
  }

  // Initializes XMLHttpRequest listeners.
  _initListeners(resolve, reject, file) {
    const xhr = this.xhr;
    const loader = this.loader;
    // const genericErrorText = `Couldn't upload file: ${file.name}.`;

    xhr.addEventListener("error", () => reject(genericErrorText));
    xhr.addEventListener("abort", () => reject());
    xhr.addEventListener("load", () => {
      const response = xhr.response;

      // This example assumes the XHR server's "response" object will come with
      // an "error" which has its own "message" that can be passed to reject()
      // in the upload promise.
      //
      // Your integration may handle upload errors in a different way so make sure
      // it is done properly. The reject() function must be called when the upload fails.
      if (!response || response.error) {
        return reject(
          response && response.error ? response.error.message : genericErrorText
        );
      }

      // If the upload is successful, resolve the upload promise with an object containing
      // at least the "default" URL, pointing to the image on the server.
      // This URL will be used to display the image in the content. Learn more in the
      // UploadAdapter#upload documentation.
      resolve({
        default: response.url,
      });
    });

    // Upload progress when it is supported. The file loader has the #uploadTotal and #uploaded
    // properties which are used e.g. to display the upload progress bar in the editor
    // user interface.
    if (xhr.upload) {
      xhr.upload.addEventListener("progress", (evt) => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      });
    }
  }

  // Prepares the data and sends the request.
  _sendRequest(file) {
    // Prepare the form data.
    const data = new FormData();

    data.append("upload", file);

    // Important note: This is the right place to implement security mechanisms
    // like authentication and CSRF protection. For instance, you can use
    // XMLHttpRequest.setRequestHeader() to set the request headers containing
    // the CSRF token generated earlier by your application.

    // Send the request.
    this.xhr.send(data);
  }
}

function MyUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = function (loader) {
    return new MyUploadAdapter(loader);
  };
}

export default {
  data() {
    return {
      ticketCategories: [],
      ticket: [],
      customer_id:'',
      plugins: ["SimpleUploadAdapter"],
      editorConfig: {
        extraPlugins: [MyUploadAdapterPlugin],
      },

      editor: ClassicEditor,
      editorData: "",
    };
  },
  components: { ClassicEditor, vSelect },
  directives: { mask },
  methods: {
    makeFormData() {
      let fd = new FormData();

      fd.append("subject", this.ticket.subject);

      const id = this.$route.params.id;
      if (id) {
        fd.append("ticket_id", this.$route.params.id);
        fd.append("body", this.ticket.description);
        fd.append("order", 1);
        fd.append("status", 1);
        // fd.append("_method", "PUT");
      } else {
        fd.append("description", this.ticket.description);
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "new_tickets";

      const fd = self.makeFormData();
      fd.append("user_id", this.$store.getters.user.id);

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", `Cadastrado com sucesso`, "success");
          self.$router.push({ path: "/tickets" });
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    calculateTotalTimeServiceHours() {
      let total = 0;

      this.ticket.service_hours.forEach((service_hour) => {

        let startMoment = moment(service_hour.start);
        let endMoment = moment(service_hour.end);

        let duration = moment.duration(endMoment.diff(startMoment));

        total += duration.asSeconds();
      });

      return this.$secondsToTimeFormated(total);
    },
    getTicket(id) {
      const self = this;
      self.$http
        .get(self.$store.getters.api + "new_tickets/" + id, {
          params: {
            with: [
              "interactions",
              "sent_by",
              "devs",
              "responsible",
              "service_hours",
              "attachments",
            ],
          },
        })
        .then((response) => {
          self.ticket = response.data.data[0];
        });
    },
    getTicketCategories() {
      const self = this;
      self.$http
        .get(self.$store.getters.api + "ticketcategories/?paginated=false")
        .then((response) => {
          self.ticketCategories = response.data.data;
        });
    },
    saveAttachments: function () {
      let api = this.$store.state.api + "new_ticket-attach";
      const self = this;

      let form = new FormData();

      form.append("user_id", self.$store.getters.user.id);
      form.append("ticket_id", self.ticket.id);

      let attachment = document.getElementById("attachment").files[0];
      if (attachment) {
        form.append("attachment", attachment);
      }

      self.$http
        .post(api, form)
        .then((response) => {
          self.$message("Sucesso", `Anexo Guardado com sucesso`, "success");
          $("#attachModal").hide();
          self.getProjectsContent();
        })
        .catch((error) => {
          self.errors = error.response.data;

          if (typeof self.errors === "object") {
            let html = "<ul>";

            $.each(self.errors, function (key, value) {
              html += "<li>" + value[0] + "</li>";
            });

            html += "</ul>";

            self.errors = html;
          }

          self.$message(null, self.errors, "error");
        });
    },
    save: function () {
      const self = this;

      const id = self.$route.params.id;

      if (id) {
        var endpoint = "tickets_interactions";
      } else {
        var endpoint = "new_tickets";
      }

      let api = self.$store.state.api + endpoint;

      const fd = self.makeFormData();

      fd.append("customer_id", this.$store.getters.user.id);

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", `Cadastrado com sucesso`, "success");
          if (id) {
            this.getTicket(id);
          } else {
            self.$router.push({ path: "/tickets" });
          }
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    calculateTotalTimeServiceHours() {
      let total = 0;

      this.ticket.service_hours.forEach((service_hour) => {

        let startMoment = moment(service_hour.start);
        let endMoment = moment(service_hour.end);

        let duration = moment.duration(endMoment.diff(startMoment));

        total += duration.asSeconds();
      });

      return this.$secondsToTimeFormated(total);
    },
    getTicket(id) {
      const self = this;
      self.$http
        .get(self.$store.getters.api + "new_tickets/" + id, {
          params: {
            with: [
              "interactions",
              "attachments",
              "sent_by",
              "devs",
              "responsible",
              "service_hours",
            ],
          },
        })
        .then((response) => {
          self.ticket = response.data.data[0];
        });
    },
    getTicketCategories() {
      const self = this;
      self.$http
        .get(self.$store.getters.api + "ticketcategories/?paginated=false")
        .then((response) => {
          self.ticketCategories = response.data.data;
        });
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.getTicket(id);
    }
    this.getTicketCategories();
  },
};
</script>
<style scoped>
.hidden {
  display: none;
}

#message {
  height: 40px !important;
  min-height: 40px !important ;
}

.ipp-alert {
  padding: 5px !important;
  margin-left: -25px !important;
  margin-bottom: 0px !important;
  margin-top: 15px;
}
.photo {
  margin-top: 15px;
}

.coment-date {
  margin-bottom: 10px;
}

.darker {
  border-color: #ccc;
  background-color: #ddd;
}
.container-fluid,
.container {
  border: 2px solid #dedede;
  background-color: #f1f1f1;
  border-radius: 5px;
  padding: 10px;
  margin: 10px 0;
}

.container-fluid::after,
.container::after {
  content: "";
  clear: both;
  display: table;
}

.time-right {
  float: right;
  color: #aaa;
}

.time-left {
  float: left;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/Ticket/Ticket.vue